import React from "react";
import { Link as SmoothLink } from "react-scroll";
const About = () => {
  return (
    <div id="about" className="lg:my-20 my-10 px-8 lg:px-36">
      <h2
        data-aos="zoom-in"
        data-aos-delay="300"
        data-aos-duration="1500"
        data-aos-offset="500"
        data-aos-mirror="true"
        className="lg:hidden text-center lg:text-5xl text-4xl mb-5 lg:mb-10 font-[500]"
      >
        About me
      </h2>
      <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-2 lg:gap-12 items-center">
        <div className="lg:order-1 md:order-1 order-2">
          <h2 className="lg:block hidden lg:text-5xl text-4xl mb-10 font-[500]">
            About me
          </h2>
          <p className="text-lg leading-loose text-justify lg:mt-10">
            I'm Md. Muntasir Hossain a passionate Front-End developer from
            Narayanganj District, Bangladesh. I am focused on building
            responsive, feature packed & user friendly web applications by using
            HTML5, CSS3, JavaScript, MongoDB, Express.js, React JS and Node.js.
            I am open to work. If I can do any task for you, feel free to{" "}
            <SmoothLink
              activeclassname="active"
              to="contact"
              spy={true}
              smooth={true}
              offset={-70}
              duration={600}
              isDynamic={true}
            >
              <span className="text-blue-500 border-b border-accent cursor-pointer">
                contact me
              </span>
            </SmoothLink>
            .
          </p>
        </div>
        <div className="lg:order-2 md:order-2 order-1">
          <img
            src="Images/me.png"
            className="lg:h-[500px] lg:w-[500px] lg:ml-20"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default About;
